import React from 'react';
import type { ISnapIcon } from '../icons-mapper';

export const XSolid = (props: ISnapIcon) => {
  const { size, title, color = 'currentColor' } = props;
  return (
    <svg
      height={size}
      width={size}
      viewBox='0 0 24 24'
      fill={color}
      xmlns='http://www.w3.org/2000/svg'
    >
      <title>{title}</title>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.15161 5.1515C5.37664 4.92654 5.68181 4.80016 6.00001 4.80016C6.3182 4.80016 6.62337 4.92654 6.84841 5.1515L12 10.3031L17.1516 5.1515C17.2623 5.03689 17.3947 4.94547 17.5411 4.88258C17.6875 4.81969 17.845 4.78659 18.0043 4.7852C18.1637 4.78382 18.3217 4.81418 18.4692 4.87452C18.6166 4.93485 18.7506 5.02396 18.8633 5.13663C18.976 5.2493 19.0651 5.38328 19.1254 5.53076C19.1857 5.67823 19.2161 5.83625 19.2147 5.99558C19.2133 6.15492 19.1802 6.31238 19.1173 6.45879C19.0544 6.60519 18.963 6.73761 18.8484 6.8483L13.6968 11.9999L18.8484 17.1515C19.067 17.3778 19.1879 17.6809 19.1852 17.9956C19.1825 18.3102 19.0563 18.6112 18.8338 18.8337C18.6113 19.0562 18.3103 19.1824 17.9957 19.1851C17.6811 19.1878 17.3779 19.0669 17.1516 18.8483L12 13.6967L6.84841 18.8483C6.62208 19.0669 6.31896 19.1878 6.00432 19.1851C5.68969 19.1824 5.38871 19.0562 5.16622 18.8337C4.94373 18.6112 4.81753 18.3102 4.8148 17.9956C4.81206 17.6809 4.93302 17.3778 5.15161 17.1515L10.3032 11.9999L5.15161 6.8483C4.92664 6.62327 4.80026 6.3181 4.80026 5.9999C4.80026 5.68171 4.92664 5.37654 5.15161 5.1515Z'
      />
    </svg>
  );
};
